import {
  PROPERTY_ATMORE,
  PROPERTY_BETHLEHEM,
  PROPERTY_CHECK_IN_OUT_TIMES,
  PROPERTY_MONTGOMERY,
  PROPERTY_TIMEZONES,
  PROPERTY_WETUMPKA,
  PROPERTY_CHICAGO
} from 'utils/constants';
import moment from 'moment-timezone';

export const CANCELLATION_POLICY = property => {
  const checkInOutTime = PROPERTY_CHECK_IN_OUT_TIMES[property];
  const timezone = PROPERTY_TIMEZONES[property];

  return `Cancellation must be received 24 hours prior to our ${moment
    .tz(checkInOutTime.checkIn, 'HH:mm:ss', timezone)
    .format('ha')} check-in
  time or you will be subject to first night’s room and tax and
  forfeiture of your room offers. If the credit card given is not
  valid, we cannot guarantee your reservation past a 6pm check-in
  time. Please be prepared to present a credit card in your name
  upon arrival as we do require a $50 authorization on all
  reservations to cover any incidentals that may occur with the
  room. This hold will be released back to your financial
  institution within 24 hours of check out. It may take 7-10
  business days for the funds to become available, depending on the institution.`;
};

export const PROPERTY_TERMS_AND_CONDITIONS_FULL = {
  [PROPERTY_ATMORE]: null,
  [PROPERTY_BETHLEHEM]: [
    'You must be at least 21 years of age to check-in and register for a room.',
    'A valid credit card is required to secure your reservation only and will not be charged until check-in.',
    'Valid identification is required upon check-in.',
    'All reservation requests must have the first and last name of the adult guest occupying the room.',
    'Limit of 4 guests per room.',
    'Preferred room type is on a request basis only. Actual room type assigned at check-in.',
    "When using your credit card to check-in, the entire stay's room and tax will be secured unless otherwise stated in your group contract. Additionally, a minimum incidental authorization of $50 ($50 for open charging privileges per night) will also be secured. Authorized funds not utilized will be released upon check-out or within 24 - 48 hours.",
    "When using your debit card to check-in, the entire stay's room and tax charges will be charged immediately unless otherwise stated in your group contract. Additionally, a minimum incidental charge of $50 ($50 for open charging privileges per night) will also be charged immediately. Any charges not utilized will be credited back to your debit card upon check-out. Credited funds may take up to 10 business days to be refunded to your account.",
    'If you wish to use your points towards your final bill, you must check out at the front desk unless charges were previously settled by a Casino Host.',
    'Rates are based on double occupancy. $25 will be charged for additional guests 12 years of age and older.',
    'Check-in time is 4:00PM. Check-out time is 10:00AM. Any reservation not checked-in by 11:00PM without prior approval may be canceled.',
    'Valet or self-parking available. Valet charge is $7 per night.',
    'Cancellation of and/or amendments to your reservation must be made by 6PM day prior to arrival. Package cancellation terms may vary. See package details for clarification.',
    "Cancellations of and/or amendments to your reservation after 6pm day prior to arrival, or outside the package cancellation terms, are subject to a cancellation fee of one night's room charge (inclusive of any applicable tax and package components).",
    "In the event of no-show, a fee of one night's room charge (inclusive of any applicable tax) will be incurred and assessed to your credit card provided at the time of reservation.",
    'For reservations for groups of 10 rooms and above, please call 877-726-3777.',
    'In proceeding with the reservation, you further agree to allow the Hotel or any of its related corporations to send you information on upcoming events and promotions; and or related information via email to the email address provided.',
    'You may unsubscribe to any such email at anytime upon receipt of said email.',
    'Exhibiting and/or sale of goods, products or services are not permitted in guest rooms.',
    'Non-confirmed rates are subject to change without notice.',
    'If booking this room as a gift for another guest, you must call 877-726-3777 to complete this reservation. Gift reservations cannot be booked online.'
  ],
  [PROPERTY_MONTGOMERY]: null,
  [PROPERTY_WETUMPKA]: null,
  [PROPERTY_CHICAGO]: null // TODO: add any new T&Cs here
};
